// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Gallery_wrapper__23Kab","list":"Gallery_list__1KqD5","none":"Gallery_none__3CriR","fade":"Gallery_fade__3_WHN","fadeIn":"Gallery_fadeIn__3tgBi"};